import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import ErrorFallback from './ErrorFallback';

interface RouteErrorFallbackProps {
  error: Error;
  retry: () => void;
}

// The props Next hands app/error.tsx and app/global-error.tsx; the boundary is Next's, so the report is made here.
const RouteErrorFallback = ({ error, retry }: RouteErrorFallbackProps) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <ErrorFallback error={error} componentStack="" eventId="" resetError={retry} />;
};

export default RouteErrorFallback;
